export default __webpack_public_path__ + "static/media/financial.ea965fb8.svg";